import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./Screens/LandingPage";
import AuthPage from "./Screens/AuthPage";
import AnnotatePage from "./Screens/AnnotatePage";
import ContactPage from "./Screens/ContactPage";
import DashboardPage from "./Screens/DashboardPage";
import CapturedImagesPage from "./Screens/CapturedImagesPage";
import PendingApprovalPage from "./Screens/PendingApprovalPage";
import AnalyticsControls from "./components/AnalyticsControls";

function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/pending" element={<PendingApprovalPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/annotate" element={<AnnotatePage />} />
          <Route path="/captures" element={<CapturedImagesPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <AnalyticsControls />
      </div>
    </Router>
  );
}

export default App;
